<template>

<div id="dynasties-container">

  <LoaderComponent v-if="!loaded" />
  <div v-else id="dynasties">
    <select
      id="dynasties-country" 
      v-model="dynasty">
      <option selected disabled value="">{{ $i18n.t("IslDyn_dropdown") }}</option>
      <option v-for="dynasty in dynasties" :key="dynasty.id" :value="dynasty.id">
        {{ dynasty.name }}
      </option>
    </select>

    <div id="dynasties-go">
      <button @click="goToDynasty()">{{ $i18n.t("my_go") }}</button>
    </div>
  </div>

  <div id="dynasties-description">
    <div v-html="$i18n.t('dynastiesIntro')"
      :dir="siteLanguage === 'ar' ? 'rtl' : 'ltr'">
    </div>
  </div>

</div>

</template>



<script>

import { loadLocaleMessages } from "../i18n.js";
import LoaderComponent from "../components/LoaderComponent.vue";
import language from "../mixins/language.js";
export default {
  name: "DynastiesPage",
  props: ["siteLanguage"],
  components: {
    "LoaderComponent": LoaderComponent
  },
  mixins: [language],
  data() {
    return {
      loaded: false,
      dynasties: [],
      allInfo: [],
      dynasty: "",
    }
  },
  watch: {
    "siteLanguage" () {
      loadLocaleMessages(this.siteLanguage);
      let dynasties = [];
      for (let i = 0; i < this.allInfo.length; i++) {
        let dynasty = {};
        dynasty.id = this.allInfo[i].dynastyId;
        dynasty.name = this.returnValueInLanguage(this.siteLanguage, this.allInfo[i].dynastyName).name;
        dynasties.push(dynasty);
      }
      let alphabetized = dynasties.sort((a, b) => {
        if (a.name < b.name) {
          return -1;
        } else if (a.name > b.name) {
          return 1;
        }
        return 0;
      });
      this.dynasties = alphabetized;
    }
  },
  methods: {
    getDynasties: function() {
      return axios({ method: "GET", "url": process.env.VUE_APP_API_ENDPOINT + "/dynasties" }).then(result => {
        this.allInfo = result.data;
        let dynasties = [];
        for (let i = 0; i < this.allInfo.length; i++) {
          let dynasty = {};
          dynasty.id = this.allInfo[i].dynastyId;
          dynasty.name = this.returnValueInLanguage(this.siteLanguage, this.allInfo[i].dynastyName).name;
          dynasties.push(dynasty);
        }
        let alphabetized = dynasties.sort((a, b) => {
          if (a.name < b.name) {
            return -1;
          } else if (a.name > b.name) {
            return 1;
          }
          return 0;
        });
        this.dynasties = alphabetized;
        this.loaded = true;
      }, error => {
        console.error(error);
      });
    },
    goToDynasty: function() {
      if (this.dynasty === "") {
        alert ("Please select a Dynasty.");
        return;
      }
      this.$router.push({ 
        name: "dynasty", 
        params: { 
          id: this.dynasty ,
          language: this.siteLanguage
        } 
      });
    }
  },
  mounted() {
    this.getDynasties();
    loadLocaleMessages(this.siteLanguage);
  },
  // Load i18n messages in selected language
  beforeRouteEnter(to, from, next) {
    loadLocaleMessages("en").then(() => next()); 
  },
  beforeRouteUpdate(to, from, next) {
    loadLocaleMessages(this.siteLanguage).then(() => next());
  }
}

</script>



<style scoped lang="scss">

#dynasties-container {
  @include flex-center;
  align-items: flex-start;
  width: 100%;
  background-color: white;
}

.loader-container {
  min-height: 300px;
  width: 40%;
}

#dynasties {
  @include flex-center;
  align-items: flex-start;
  flex-direction: column;
  width: 45%;
  padding: 60px;
}
  #dynasties select {
    padding: 4px;
  }
    #dynasties-country,
    #dynasties-dates-container {
      width: 100%;
      max-width: 350px;
    }
    #dynasties-dates-container {
      @include flex-center;
      justify-content: space-between;
      margin: 15px 0;
    }
    #dynasties-start-date,
    #dynasties-end-date {
      width: 48%;
    }
  #dynasties-go {
    @include flex-center;
    width: 100%;
    max-width: 350px;
  }
    #dynasties-go button {
      @include button-styles;
      background-color: $theme-light;
      color: $text-color;
      padding: 4px 15px;
      border-radius: 100px;
      margin-top: 10px;
    }

#dynasties-description {
  width: 55%;
  padding: 50px 75px 50px 0;
}
  #dynasties-description a {
    @include link-styles;
  }
    #dynasties-description a:hover {
      @include link-hover-styles;
    }
  .break {
    padding-bottom: 15px;
  }
  .italic {
    font-style: italic;
  }

@media only screen and (max-width: 849px) {
  #dynasties-container {
    flex-direction: column;
  }
    .loader-container {
      min-height: 250px;
      width: 100%;
    }
    #dynasties {
      width: 100%;
      align-items: center;
    }
    #dynasties-description {
      align-self: center;
      width: 100%;
      padding: 0 50px 50px 50px;
      margin-top: 0;
    }
}

@media only screen and (max-width: 599px) {
  #dynasties {
    padding: 30px;
  }
  #dynasties-description {
    padding: 0 30px 30px 30px;
  }
}

</style>